import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../../store/Slices/formSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function CroatiaEnglish() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Croatia') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState();
    const [vat, setVat] = useState();
    const [authorizedPerson, setAuthorizedPerson] = useState();
    const [phone, setPhone] = useState();
    const [email, setEmail] = useState();
    const [contract, setContract] = useState();
    const [aware, setAware] = useState(false);

    const [losing, setLosing] = useState();
    const [gaining, setGaining] = useState();

    const [aware2, setAware2] = useState(false);
    const [porting, setPorting] = useState();
    const [vpn, setVpn] = useState();
    const [address, setAddress] = useState();
    const [terminate, setTerminate] = useState();
    const [keep, setKeep] = useState();
    const [retained, setRetained] = useState();
    const [related, setRelated] = useState();

    const [place, setPlace] = useState();
    const [date, setDate] = useState('');
    const [cSignature, setCSignature] = useState();
    const [stamp, setStamp] = useState();
    const [aSignature, setASignature] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setName(JSONDATA?.country?.details?.name ?? '');
        document.querySelector('#name').value = JSONDATA?.country?.details?.name ?? '';

        setVat(JSONDATA?.country?.details?.vat ?? '');
        document.querySelector('#vat').value = JSONDATA?.country?.details?.vat ?? '';

        setAuthorizedPerson(JSONDATA?.country?.details?.authorizedPerson ?? '');
        document.querySelector('#authorizedPerson').value = JSONDATA?.country?.details?.authorizedPerson ?? '';

        setTableDataRange(JSONDATA?.country?.details?.tableDataRange ?? []);

        setPhone(JSONDATA?.country?.details?.phone ?? '');
        document.querySelector('#phone').value = JSONDATA?.country?.details?.phone ?? '';

        setEmail(JSONDATA?.country?.details?.email ?? '');
        document.querySelector('#email').value = JSONDATA?.country?.details?.email ?? '';

        setContract(JSONDATA?.country?.details?.contract ?? '');
        document.querySelector('#contract').value = JSONDATA?.country?.details?.contract ?? '';

        setAware(JSONDATA?.country?.details?.aware ?? false);
        document.querySelector('#aware').checked = JSONDATA?.country?.details?.aware ?? false;

        setLosing(JSONDATA?.country?.details?.losing ?? '');
        document.querySelector('#losing').value = JSONDATA?.country?.details?.losing ?? '';

        setGaining(JSONDATA?.country?.details?.gaining ?? '');
        document.querySelector('#gaining').value = JSONDATA?.country?.details?.gaining ?? '';

        setAware2(JSONDATA?.country?.details?.aware2 ?? false);
        document.querySelector('#aware2').checked = JSONDATA?.country?.details?.aware2 ?? false;

        setPorting(JSONDATA?.country?.details?.porting ?? '');
        document.querySelector('#porting').value = JSONDATA?.country?.details?.porting ?? '';

        setVpn(JSONDATA?.country?.details?.vpn ?? '');
        document.querySelector('#vpn').value = JSONDATA?.country?.details?.vpn ?? '';

        setAddress(JSONDATA?.country?.details?.address ?? '');
        document.querySelector('#address').value = JSONDATA?.country?.details?.address ?? '';

        setTerminate(JSONDATA?.country?.details?.terminate ?? '');
        document.querySelector('#terminate').value = JSONDATA?.country?.details?.terminate ?? '';

        setKeep(JSONDATA?.country?.details?.keep ?? '');
        document.querySelector('#keep').value = JSONDATA?.country?.details?.keep ?? '';

        setRetained(JSONDATA?.country?.details?.retained ?? '');
        document.querySelector('#retained').value = JSONDATA?.country?.details?.retained ?? '';

        setRelated(JSONDATA?.country?.details?.related ?? '');
        document.querySelector('#related').value = JSONDATA?.country?.details?.related ?? '';

        setPlace(JSONDATA?.country?.details?.place ?? '');
        document.querySelector('#place').value = JSONDATA?.country?.details?.place ?? '';

        setDate(JSONDATA?.country?.details?.date ?? '');
        document.querySelector('#date').value = JSONDATA?.country?.details?.date ?? '';

        setCSignature(JSONDATA?.country?.details?.cSignature ?? '');
        document.querySelector('#cSignature').value = JSONDATA?.country?.details?.cSignature ?? '';

        setStamp(JSONDATA?.country?.details?.stamp ?? '');
        document.querySelector('#stamp').value = JSONDATA?.country?.details?.stamp ?? '';

        setASignature(JSONDATA?.country?.details?.aSignature ?? '');
        document.querySelector('#aSignature').value = JSONDATA?.country?.details?.aSignature ?? '';

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must not be empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^[\s\S]+$/.test(row.sNumber);
                const isEndValid = /^[\s\S]+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Croatia_English",

            "details": {
                "name": name,
                "vat": vat,
                "authorizedPerson": authorizedPerson,
                "tableDataRange": tableDataRange,
                "phone": phone,
                "email": email,
                "contract": contract,
                "aware": aware,
                "losing": losing,
                "gaining": gaining,
                "aware2": aware2,
                "porting": porting,
                "vpn": vpn,
                "address": address,
                "terminate": terminate,
                "keep": keep,
                "retained": retained,
                "related": related,
                "place": place,
                "date": date,
                "cSignature": cSignature,
                "stamp": stamp,
                "aSignature": aSignature
            }

        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        let validationErrors = {};

        if (!name) {
            validationErrors.name = 'Please fill in Name and Surname/Company';
        }
        if (!vat) {
            validationErrors.vat = 'Please fill in VAT or personal identification number';
        }

        if (!authorizedPerson) {
            validationErrors.authorizedPerson = 'Please fill in Name and surname of the authorized person';
        }

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^[+]?[0-9]+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^[+]?[0-9]+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!phone) {
            validationErrors.phone = "Please fill in Contact's phone number";
        }

        if (!email) {
            validationErrors.email = "Please fill in Contact 's email address";
        }

        if (!contract) {
            validationErrors.contract = 'Please select Contract Concluded at a Distance';
        }

        if (!aware) {
            validationErrors.aware = 'Please check the awareness confirmation';
        }

        if (!losing) {
            validationErrors.losing = 'Please fill in Name of the number provider/losing carrier';
        }

        if (!gaining) {
            validationErrors.gaining = 'Please fill in Name of the recipient of the number/gaining carrier';
        }

        if (!aware2) {
            validationErrors.aware2 = 'Please check the awareness confirmation';
        }

        if (!porting) {
            validationErrors.porting = 'Please select Number porting';
        }

        if (!vpn) {
            validationErrors.vpn = 'Please select VPN series or series on a port';
        }

        if (!address) {
            validationErrors.address = 'Please fill in Address';
        }

        if (!terminate) {
            validationErrors.terminate = 'Please select Services that the user wants to terminate with the existing operator';
        }

        if (!keep) {
            validationErrors.keep = 'Please select Services that the user wants to keep with the existing operator';
        }

        if (!retained) {
            validationErrors.retained = 'Please select In connection with the internet access service, user accounts are retained';
        }

        if (!related) {
            validationErrors.related = 'Please select The request to change the operator is related to the wholesale service';
        }

        if (!place) {
            validationErrors.place = 'Please fill in Place';
        }

        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }

        if (!cSignature) {
            validationErrors.cSignature = "Please fill in Company's Signature";
        }

        if (!stamp) {
            validationErrors.stamp = 'Please fill in Stamp';
        }

        if (!aSignature) {
            validationErrors.aSignature = 'Please fill in Signature of the Authorized Person';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message and scroll to the field if it exists
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorElement = document.getElementById(firstErrorKey);

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${firstErrorKey} not found.`);
                toast.error("An error occurred while scrolling to the invalid field.");
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            } else {
                console.error(`Element with ID ${falseKeys[0]} not found.`);
            }
            return;
        }

        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = name + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <Container>

                    <h2 className='heading'>Information About User</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name and Surname/Company*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id='name'
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter Name and Surname/Company
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vat')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>VAT or personal identification number*</label> <br />
                            <input
                                onChange={(e) => setVat(e.target.value)}
                                type="text"
                                id="vat"
                                placeholder=""
                                className={`inputbox ${validationStates.vat === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vat', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'vat' && (
                                <div className="hover-description">
                                    Enter VAT or personal identification number
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('authorizedPerson')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name and surname of the authorized person (only for legal entities)*</label> <br />
                            <input
                                onChange={(e) => setAuthorizedPerson(e.target.value)}
                                type="text"
                                id="authorizedPerson"
                                placeholder=""
                                className={`inputbox ${validationStates.authorizedPerson === false ? 'error' : ''}`}
                                onBlur={() => validateInput('authorizedPerson', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'authorizedPerson' && (
                                <div className="hover-description">
                                    Enter Name and surname of the authorized person (only for legal entities)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <h4 className='text-decoration-underline'>Number Range</h4>

                    <Row>
                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <br />

                    <p>The template is the same used for the btd portability request.</p>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start*</th>
                                <th>Number range end*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^[\s\S]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[\s\S]+$/.test(row.sNumber);

                                                if (!isValid) {
                                                    toast.error('Only alphanumeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />

                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start number in a range
                                            </div>
                                        )}

                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only alphanumeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^[\s\S]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[\s\S]+$/.test(row.eNumber);

                                                if (!isValid) {
                                                    toast.error('Only alphanumeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />

                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end number in a range
                                            </div>
                                        )}

                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only alphanumeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('phone')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact's phone number*</label> <br />
                            <input
                                onChange={(e) => setPhone(e.target.value)}
                                type="text"
                                id="phone"
                                placeholder=""
                                className={`inputbox ${validationStates.phone === false ? 'error' : ''}`}
                                onBlur={() => validateInput('phone', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'phone' && (
                                <div className="hover-description">
                                    Enter Contact's phone number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contact 's email address*</label> <br />
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id="email"
                                placeholder=""
                                className={`inputbox ${validationStates.email === false ? 'error' : ''}`}
                                onBlur={() => validateInput('email', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Enter Contact 's email address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contract')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Contract Concluded at a Distance*</label> <br />
                            <select
                                id="contract"
                                value={contract || ''}
                                onChange={(e) => setContract(e.target.value)}
                                onBlur={() => validateInput('contract', /^(Yes|No)$/)}
                                className={`inputbox ${validationStates.contract === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            {hoveredField === 'contract' && (
                                <div className="hover-description">
                                    Enter Contract Concluded at a Distance
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <label>
                                <input
                                    type="checkbox"
                                    id="aware"
                                    checked={aware}
                                    onChange={(e) => setAware(e.target.checked)}
                                    className={validationStates.aware === false ? 'error' : ''}
                                />
                                The user is aware of and agrees to settle the debts owed to the existing operator/s due to the early contract termination*
                            </label>
                        </Col>
                    </Row>
                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>OPERATOR DATA</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('losing')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name of the number provider/losing carrier*</label> <br />
                            <input
                                onChange={(e) => setLosing(e.target.value)}
                                type="text"
                                id="losing"
                                placeholder=""
                                className={`inputbox ${validationStates.losing === false ? 'error' : ''}`}
                                onBlur={() => validateInput('losing', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'losing' && (
                                <div className="hover-description">
                                    Enter Name of the number provider/losing carrier
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('gaining')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name of the recipient of the number/gaining carrier*</label> <br />
                            <input
                                onChange={(e) => setGaining(e.target.value)}
                                type="text"
                                id="gaining"
                                placeholder=""
                                className={`inputbox ${validationStates.gaining === false ? 'error' : ''}`}
                                onBlur={() => validateInput('gaining', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'gaining' && (
                                <div className="hover-description">
                                    Enter Name of the recipient of the number/gaining carrier
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>SERVICES IN A FIXED NETWORK</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('aware2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>
                                <input
                                    type="checkbox"
                                    id="aware2"
                                    checked={aware2}
                                    onChange={(e) => setAware2(e.target.checked)}
                                    className={validationStates.aware2 === false ? 'error' : ''}
                                />
                                The user is aware that he will be informed about the date of the change of operator within 15 days*
                            </label>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('porting')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Number porting*</label> <br />
                            <select
                                id="porting"
                                value={porting || ''}
                                onChange={(e) => setPorting(e.target.value)}
                                onBlur={() => validateInput('porting', /^(Yes|No)$/)}
                                className={`inputbox ${validationStates.porting === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            {hoveredField === 'porting' && (
                                <div className="hover-description">
                                    Enter Number porting
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vpn')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>VPN series or series on a port*</label> <br />
                            <select
                                id="vpn"
                                value={vpn || ''}
                                onChange={(e) => setVpn(e.target.value)}
                                onBlur={() => validateInput('vpn', /^(Yes|No)$/)}
                                className={`inputbox ${validationStates.vpn === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            {hoveredField === 'vpn' && (
                                <div className="hover-description">
                                    Enter VPN series or series on a port
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter Address
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('terminate')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Services that the user wants to terminate with the existing operator*</label> <br />
                            <select
                                id="terminate"
                                value={terminate || ''}
                                onChange={(e) => setTerminate(e.target.value)}
                                onBlur={() => validateInput(
                                    'terminate',
                                    /^(Network access|Voice service|Internet|TV|All services)$/
                                )}
                                className={`inputbox ${validationStates.terminate === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Network access">Network access</option>
                                <option value="Voice service">Voice service</option>
                                <option value="Internet">Internet</option>
                                <option value="TV">TV</option>
                                <option value="All services">All services</option>
                            </select>

                            {hoveredField === 'terminate' && (
                                <div className="hover-description">
                                    Enter Services that the user wants to terminate with the existing operator
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('keep')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Services that the user wants to keep with the existing operator*</label> <br />
                            <select
                                id="keep"
                                value={keep || ''}
                                onChange={(e) => setKeep(e.target.value)}
                                onBlur={() => validateInput(
                                    'keep',
                                    /^(Network access|Voice service|Internet|TV|All services)$/
                                )}
                                className={`inputbox ${validationStates.keep === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Network access">Network access</option>
                                <option value="Voice service">Voice service</option>
                                <option value="Internet">Internet</option>
                                <option value="TV">TV</option>
                                <option value="All services">All services</option>
                            </select>

                            {hoveredField === 'keep' && (
                                <div className="hover-description">
                                    Enter Services that the user wants to keep with the existing operator
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('retained')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>In connection with the internet access service, user accounts are retained*</label> <br />
                            <select
                                id="retained"
                                value={retained || ''}
                                onChange={(e) => setRetained(e.target.value)}
                                onBlur={() => validateInput(
                                    'retained',
                                    /^(Web hosting|E-mail addresses|All user accounts)$/
                                )}
                                className={`inputbox ${validationStates.retained === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Web hosting">Web hosting</option>
                                <option value="E-mail addresses">E-mail addresses</option>
                                <option value="All user accounts">All user accounts</option>
                            </select>

                            {hoveredField === 'retained' && (
                                <div className="hover-description">
                                    Enter In connection with the internet access service, user accounts are retained
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('related')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>The request to change the operator is related to the wholesale service*</label> <br />
                            <select
                                id="related"
                                value={related || ''}
                                onChange={(e) => setRelated(e.target.value)}
                                onBlur={() => validateInput('related', /^(Yes|No)$/)}
                                className={`inputbox ${validationStates.related === false ? 'error' : ''}`}
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            {hoveredField === 'related' && (
                                <div className="hover-description">
                                    Enter The request to change the operator is related to the wholesale service
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>PLACE, DATE AND SIGNATURES</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('place')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Place*</label> <br />
                            <input
                                onChange={(e) => setPlace(e.target.value)}
                                type="text"
                                id="place"
                                placeholder=""
                                className={`inputbox ${validationStates.place === false ? 'error' : ''}`}
                                onBlur={() => validateInput('place', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'place' && (
                                <div className="hover-description">
                                    Enter Place
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Date*</label> <br />
                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Date
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cSignature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company's Signature*</label> <br />
                            <input
                                onChange={(e) => setCSignature(e.target.value)}
                                type="text"
                                id="cSignature"
                                placeholder=""
                                className={`inputbox ${validationStates.cSignature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cSignature', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'cSignature' && (
                                <div className="hover-description">
                                    Enter Company's Signature
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('stamp')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Stamp*</label> <br />
                            <input
                                onChange={(e) => setStamp(e.target.value)}
                                type="text"
                                id="stamp"
                                placeholder=""
                                className={`inputbox ${validationStates.stamp === false ? 'error' : ''}`}
                                onBlur={() => validateInput('stamp', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'stamp' && (
                                <div className="hover-description">
                                    Enter Stamp
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('aSignature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signature of the Authorized Person*</label> <br />
                            <input
                                onChange={(e) => setASignature(e.target.value)}
                                type="text"
                                id="aSignature"
                                placeholder=""
                                className={`inputbox ${validationStates.aSignature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('aSignature', /^[\s\S]*$/)}
                            />

                            {hoveredField === 'aSignature' && (
                                <div className="hover-description">
                                    Enter Signature of the Authorized Person
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default CroatiaEnglish;